export interface Doctor {
  personalDetailsFields: DoctorField[];
  financialDetailsFields: DoctorField[];
  residenceFields: DoctorField[];
  fiscalFields: DoctorField[];
  [key: string]: DoctorField[];
}

export interface DoctorField {
  label: string;
  description: string;
  class?: string;
}

export interface Module {
  id: string;
  category: string;
  title: string;
  date_added: string;
  file_content_type: string;
}

export interface CalendarGoogle {
  id: string;
  backgroundColor: string;
  summary: string;
  role: string;
}

export interface DoctorPersonalArea {
  first_name: string;
  last_name: string;
  signin_mail: string;
}

export interface FiscalProfileOutput {
  first_name: string | null;
  last_name: string | null;
  fiscal_code: string | null;
  vat_number: string | null;
  iban: string | null;
  bank_name: string | null;
  iban_2: string | null;
  bank_name_2: string | null;
  certified_email: string | null;
  codice_univoco: string | null;
  fiscal_address: string | null;
  fiscal_street_number: string | null;
  fiscal_city: string | null;
  fiscal_province: string | null;
  fiscal_zip_code: string | null;
  regime_fiscale: string | null;
  specializzazione: string | null;
}

export interface SignInOutputData {
  access_token_google: string;
  access_token_psicogenius: string;
  avatar_blob_name: string;
  is_new_user: boolean;
  role: string;
  permissions: string[];
}

export interface ClineaseRoleResponse {
  role: ClineaseRole;
}

export interface Business {
  vat_number: string | null;
  fiscal_code: string | null;
}

export enum ClineaseRole {
  ADMIN = 'admin',
  DOCTOR_NON_PAYER = 'doctorNonPayer',
  DOCTOR_PAYER = 'doctorPayer',
  EXISTING_DOCTOR_WITHOUT_STRIPE_ACCOUNT = 'existingDoctorWithoutStripeAccount',
  EXISTING_DOCTOR_WITHOUT_STRIPE_SUBSCRIPTION = 'existingDoctorWithoutStripeSubscription',
}

export interface ClineaseSubscriptionData {
  status: ClineaseSubscriptionStatus;
  current_period_end: string;
  cancel_at_period_end: boolean;
}

export enum ClineaseSubscriptionStatus {
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  TRIALING = 'trialing',
  ACTIVE = 'active',
  PAST_DUE = 'past_due',
  CANCELED = 'canceled',
  UNPAID = 'unpaid',
  PAUSED = 'paused',
}
